import React from 'react';
import LandingNavbar from '../../components/landing/LandingNavbar';
import UpperImage from '../../components/landing/UpperImage';
import PhotoGallery from '../../containers/landing/PhotoGallery';
import Footer from '../../components/landing/Footer';

const Gallery = () => {
  return (
    <>
      <LandingNavbar />
      <UpperImage />

      <section className="relative py-16 bg-blueGray-200">
        <div className="container mx-auto px-4">
          <div className="relative flex flex-row min-w-0 bg-white w-full mb-6 shadow-xl rounded-lg -mt-64">
            <div className="px-6 py-6">
              <div className="flex flex-col">
                <div className="w-full w-auto px-4 mb-5">
                  <div className="flex flex-wrap justify-center border-b">
                    <p className="mb-4 text-lg text-2xl font-bold">GALERIJA</p>
                  </div>
                </div>
                <PhotoGallery />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Gallery;
